import { HomeMyServices } from '@core/domain/model/home/home-my-services.model';
import { HomeMyInvoices } from '@core/domain/model/home/home-my-invoices.model';

export interface HomeState {
  myServices: HomeMyServices | null;
  myInvoices: HomeMyInvoices | null;
}

export const homeInitialState: HomeState = {
  myServices: null,
  myInvoices: null,
};
